const colors = {
  // Primary and Accent Colors
  // primary: "#F05323",
  primary: "#FE7235",
  secondary: "#fea735",
  accent: "#4a71ff",
  displayBody: "#455468",
  displayLight: "#d7dee8",
  displayMedium: "#afbaca",
  displayDark: "#8897AE",
  extraGray: "#8797ae",
  gray: "#CED4DA",
  light: "#D7DFE9",
  extraLight: "#e9eff6",
  grayLight: "#f0f3f8",
  neutral: "#B18A00",

  tintInfo: "#3caaf9",
  tintDanger: "#ffa09b",
  tintWarning: "#d8a800",
  tintNeutral: "#c19c60",

  // Text Colors
  header: "#2d3643",
  subHeader: "#343a40",
  body: "#3d4a5c",
  bodyText: "#5e718d",
  muted: "#6c757d",

  // Special Cases
  highlight: "#ff574c",
  darkHighlight: "#FF574D",
  lightError: "#ffc5c1",
  error: "#e82215",
  complete: "#1db469",

  success: {
    color: "#10a65c",
    bgColor: "#e4f6ed",
  },
  danger: {
    color: "#ff3838",
    bgColor: "#fff5f4",
  },
  dark: {
    color: "#5E718D",
    bgColor: "#F0F3F9",
  },
  warning: {
    color: "#D8A800",
    bgColor: "#FFF9DF",
  },
  info: {
    color: "#820BF4",
    bgColor: "#f5ecfe",
  },
} as const;

export default colors;
